import React, { FC, useState } from 'react';
import { Box } from '@mui/material';

import { Typography } from '../Typography/Typography';
import Accordion from '../Accordion/Accordion';

import { accordionStyle } from './styles';

interface InstructionsSectionProps {
  instructions?: string[];
}

export const InstructionsSection: FC<InstructionsSectionProps> = ({
  instructions = [],
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (instructions.length === 0) {
    return null;
  }

  const instructionSteps = instructions;

  return (
    <Accordion
      title="Instructions"
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
      accordionStyle={accordionStyle}
      i18nKeyTitle="meals:dishDetails.instructions"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="16px"
        alignSelf="stretch"
      >
        {instructionSteps.map((step, index) => (
          <React.Fragment key={index}>
            <Box display="flex" alignItems="center" gap="16px">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width={40}
                height={40}
                bgcolor="grey.200"
                border="1px solid"
                borderColor="grey.300"
                borderRadius="100px"
              >
                <Typography variant="subtitle1">{index + 1}</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" flex={1}>
                {step}
              </Typography>
            </Box>
            {index < instructionSteps.length - 1 && (
              <Box
                height="1px"
                bgcolor="grey.300"
                borderRadius="2px"
                alignSelf="stretch"
              />
            )}
          </React.Fragment>
        ))}
      </Box>
    </Accordion>
  );
};

export default InstructionsSection;
